/**
 * --------------------------------------------------------------------------
 * Module: VGFlipList
 * Автор: Vegas DEV
 * Лицензия: смотри LICENSE.md
 * --------------------------------------------------------------------------
 */
import {
	findContainer,
	getDataAttributes,
	getHeight,
	listener,
	mergeDeepObject,
	toggleSlide
} from "../../_util/function";

class VGCollapse {
	constructor(container, arg = {}) {

	}

	init() {

	}

	toggle() {

	}
}

export default VGCollapse;
